import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "/tocht/";

const TochtApi = {
	ListPublishedTochtenByFilter(filter) {
		const listByUrl = prependRoot(routePrefix + "getPublishedTochtenByFilter", getApiRoot());
		return axios.post(listByUrl,
			filter,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},

	getTochtDetail(tochtId) {
		const getUrl = prependRoot(routePrefix + "detail/" + tochtId, getApiRoot());
		return axios.get(
			getUrl,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default TochtApi;